var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 bg-white my-course-wrapper"},[_c('a-tabs',{attrs:{"default-active-key":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"过期课程"}},[_c('course-content',{attrs:{"type":"expire","courseType":'overdue'}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }